// extracted by mini-css-extract-plugin
export default {"container":"HighDemandNotify_container__kbro9","icon":"HighDemandNotify_icon__2nWuT","txt":"HighDemandNotify_txt__lCGup"};